module.exports = __webpack_public_path__ + "img/gamifinnator-fly.82faff05.png";